import { NgModule } from '@angular/core';
import {
  LucideAngularModule,
  Home,
  User,
  Bell,
  CheckCircle,
  FolderCog,
  ChevronDown,
  ChevronRight,
  Edit,
  ExternalLink,
  FileText,
  FileQuestion,
  Gavel,
  HelpCircle,
  History,
  Info,
  LogOut,
  List,
  Menu,
  Plus,
  Search,
  Settings,
  Star,
  Hammer,
  Wrench,
  Megaphone,
  Pencil,
  Trash2,
  Fullscreen,
  CircleX,
  CircleGauge,
  Gauge,
  LayoutDashboard,
  Bug,
  Flag,
  Activity,
  HandCoins,
  CircleDollarSign,
  Landmark,
  ListPlus,
  FileClock,
  PanelsTopLeft,
  Library,
  BookText,
  BookMarked,
  Eye,
  Loader,
  Save,
  RectangleEllipsis,
  LayoutGrid,
  X,
  Sparkles,
  Check,
  Palette,
  Undo2,
  Calendar,
  Inbox,
  Pin,
  ThumbsUp,
  ThumbsDown,
  ShieldCheck,
  Clock,
  UserX,
  UserCheck,
  Crown,
  MoreVertical,
  Rss,
  Play,
  ChevronUp,
  EyeOff,
  SquareKanban,
  Briefcase,
  Users,
  RefreshCw,
  Undo,
  MapPin,
  MapPinned,
  Newspaper,
  Circle,
  CircleCheck,
  FileBox,
  Edit3,
  Link,
  Link2,
  MessageCircle,
  Database,
  Upload,
  UploadCloud,
  Download,
  DownloadCloud,
  FolderOpen,
  AlertTriangle,
  AlertCircle,
  Ban,
  File,
  FileCheck,
  CheckCircle2,
  Loader2,
  UserCog,
  PanelTopOpen,
  PanelTopClose,
  Compass,
  Navigation,
  FileSpreadsheet,
  FileX,
  FileSearch,
  BookDashed,
  Folder,
  FolderKanban,
  NotebookTabs,
  FolderPlus,
  FilePlus,
  ClipboardList,
  ClipboardCheck,
  Archive,
  Package,
  BarChart3,
  PieChart,
  LineChart,
  AreaChart,
  TrendingUp,
  Target,
  SlidersHorizontal,
  Building2,
  Wallet,
  CreditCard,
  Banknote,
  Scale,
  CalendarClock,
  Timer,
  UserPlus,
  Filter,
  RotateCcw,
  Replace,
  Maximize2,
  Minimize2,
  FoldVertical,
  UnfoldVertical,
  MinusSquare,
  PlusSquare,
  ZoomIn,
  ZoomOut,
  ListX,
  Combine,
  GitPullRequestDraft,
  GitPullRequestCreateArrow,
  StickyNote,
  MessageCircleQuestion,
  Mail,
  Send,
  MessageSquare,
  XCircle,
  Shield,
  Lock,
  LockOpen,
  Map,
  Camera,
  Video,
  Headphones,
  Mic,
  Image,
  BookOpen,
  GraduationCap,
  Heart,
  Bookmark,
  Zap,
  Layers,
  Table,
  Presentation,
  Award,
  Eraser,
  DatabaseBackup,
  Boxes,
  ServerCrash,
  PlayCircle,
} from 'lucide-angular';

@NgModule({
  imports: [
    LucideAngularModule.pick({
      Home,
      User,
      Ban,
      File,
      PlayCircle,
      UserCog,
      Loader2,
      FileCheck,
      CheckCircle2,
      AlertCircle,
      AlertTriangle,
      Upload,
      Settings,
      Bell,
      FolderOpen,
      UploadCloud,
      Download,
      DownloadCloud,
      CheckCircle,
      FileText,
      ExternalLink,
      FileQuestion,
      Gavel,
      LogOut,
      Menu,
      Hammer,
      ChevronDown,
      ChevronRight,
      FolderCog,
      Wrench,
      Megaphone,
      Info,
      Star,
      Search,
      Plus,
      Edit,
      HelpCircle,
      History,
      Pencil,
      Trash2,
      Fullscreen,
      CircleX,
      CircleGauge,
      Gauge,
      LayoutDashboard,
      Bug,
      Flag,
      Activity,
      HandCoins,
      CircleDollarSign,
      Landmark,
      ListPlus,
      List,
      FileClock,
      PanelsTopLeft,
      Library,
      BookText,
      BookMarked,
      Eye,
      Loader,
      Save,
      RectangleEllipsis,
      LayoutGrid,
      X,
      Sparkles,
      Check,
      Palette,
      Undo2,
      Calendar,
      Inbox,
      Pin,
      ThumbsUp,
      ThumbsDown,
      ShieldCheck,
      Clock,
      UserX,
      UserCheck,
      Crown,
      MoreVertical,
      Rss,
      Play,
      ChevronUp,
      EyeOff,
      SquareKanban,
      Briefcase,
      Users,
      RefreshCw,
      Undo,
      Circle,
      CircleCheck,
      FileBox,
      MapPin,
      MapPinned,
      Newspaper,
      Edit3,
      Link,
      Link2,
      MessageCircle,
      Database,
      // Icons from icons-dropdown
      PanelTopOpen,
      PanelTopClose,
      Compass,
      Navigation,
      FileSpreadsheet,
      FileX,
      FileSearch,
      BookDashed,
      Folder,
      FolderKanban,
      NotebookTabs,
      FolderPlus,
      FilePlus,
      ClipboardList,
      ClipboardCheck,
      Archive,
      Package,
      BarChart3,
      PieChart,
      LineChart,
      AreaChart,
      TrendingUp,
      Target,
      SlidersHorizontal,
      Building2,
      Wallet,
      CreditCard,
      Banknote,
      Scale,
      CalendarClock,
      Timer,
      UserPlus,
      Filter,
      RotateCcw,
      Replace,
      Maximize2,
      Minimize2,
      FoldVertical,
      UnfoldVertical,
      MinusSquare,
      PlusSquare,
      ZoomIn,
      ZoomOut,
      ListX,
      Combine,
      GitPullRequestDraft,
      GitPullRequestCreateArrow,
      StickyNote,
      MessageCircleQuestion,
      Mail,
      Send,
      MessageSquare,
      XCircle,
      Shield,
      Lock,
      LockOpen,
      Map,
      Camera,
      Video,
      Headphones,
      Mic,
      Image,
      BookOpen,
      GraduationCap,
      Heart,
      Bookmark,
      Zap,
      Layers,
      Table,
      Presentation,
      Award,
      Eraser,
      DatabaseBackup,
      Boxes,
      ServerCrash,
    }),
  ],
  exports: [LucideAngularModule],
  declarations: [],
  providers: [],
})
export class LucideIconsModule { }
